import api from '../lib/api';

export type RuleType = 'LABOR_LAW' | 'CHANNEL_HOURS' | 'CAPACITY_TARGET' | 'AGENT_CONSTRAINT' | 'TEAM_CONSTRAINT' | 'HOLIDAY';
export type RuleScope = 'ORGANIZATION' | 'TEAM' | 'AGENT' | 'CHANNEL';
export type RuleSeverity = 'INFO' | 'WARNING' | 'ERROR' | 'CRITICAL';

export interface BusinessRule {
  id: string;
  organizationId: string;
  ruleType: RuleType;
  scope: RuleScope;
  name: string;
  description?: string;
  conditions: any; // JSON object
  actions: any; // JSON object
  severity: RuleSeverity;
  isActive: boolean;
  appliesTo?: any; // JSON object
  createdAt: string;
  updatedAt: string;
}

export interface CreateBusinessRuleDto {
  ruleType: RuleType;
  scope: RuleScope;
  name: string;
  description?: string;
  conditions: any;
  actions: any;
  severity: RuleSeverity;
  isActive: boolean;
  appliesTo?: any;
}

export interface UpdateBusinessRuleDto {
  name?: string;
  description?: string;
  conditions?: any;
  actions?: any;
  severity?: RuleSeverity;
  isActive?: boolean;
  appliesTo?: any;
}

class BusinessRulesService {
  async getAll(organizationId?: string, ruleType?: RuleType): Promise<BusinessRule[]> {
    const params = new URLSearchParams();
    if (organizationId) params.append('organizationId', organizationId);
    if (ruleType) params.append('ruleType', ruleType);

    const response = await api.get(`/scheduling-rules?${params.toString()}`);
    return response.data;
  }

  async getById(id: string): Promise<BusinessRule> {
    const response = await api.get(`/scheduling-rules/${id}`);
    return response.data;
  }

  async create(dto: CreateBusinessRuleDto): Promise<BusinessRule> {
    const response = await api.post('/scheduling-rules', dto);
    return response.data;
  }

  async update(id: string, dto: UpdateBusinessRuleDto): Promise<BusinessRule> {
    const response = await api.patch(`/scheduling-rules/${id}`, dto);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/scheduling-rules/${id}`);
  }

  async validateSchedule(scheduleData: any): Promise<any> {
    const response = await api.post('/scheduling-rules/validate-schedule', scheduleData);
    return response.data;
  }
}

export const businessRulesService = new BusinessRulesService();
